import { Link } from "@mui/material";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { TbShirtSport } from "react-icons/tb";
import React from "react";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Sessions",
    description: "Select the 3 sessions you wish to purchase.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Connect your Mountain West account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each session.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Mountain West Account Manager within 24 hours of redemption. Reach out to Live Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title:
      "How does the Mountain West Basketball Championships 3 Session Flex Plan work?",
    description:
      "The MW Basketball Championship program allows fans to select any seats for any championship session.",
  },
  {
    title: "Do I have to select all my sessions now?",
    description:
      "Yes, you have to choose all 3 sessions you wish to purchase at time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description:
      "Event tickets are delivered directly within your Mountain West Account Manager.",
  },
];

export function TermsAndCondition() {
  return (
    <>
      <>
        By purchasing you agree to receive SMS alerts regarding ticket delivery
        and agree to the{" "}
        <Link
          // fontWeight={"bold"}
          // textDecor="underline"

          href={
            "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
          }
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          Terms & Conditions
        </Link>{" "}
        and{" "}
        <Link
          // fontWeight={"bold"}
          // textDecor="underline"
          href={
            "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
          }
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          Privacy Policy
        </Link>
        .
      </>
    </>
  );
}

export const purchaseSeatsLanguages = {
  sectionSelectorDescription: "Show Session with seats in:",
  findGamesTitle: "Featured Sessions",
  allUpcomingEventsTitle: "All Upcoming Sessions",
  purchaseSeatTabTitle: "Choose Sessions",
  bottomBarEventsDescription: "Sessions",
  noSessionsAvailable: "No sessions available",
  progressBarSuccessText: "You're good to go!",
};
